/**
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { StepLogDto } from './stepLogDto';

export interface WorkflowInstanceDto { 
    id?: string;
    definitionId?: string;
    workflowName?: string;
    reportName?: string;
    status?: WorkflowInstanceDto.StatusEnum;
    currentNodeId?: string;
    errorInfo?: string;
    parentInstanceId?: string;
    parentNodeId?: string;
    checkerName?: string;
    archived?: boolean;
    archivedAt?: Date;
    startedAt?: Date;
    completedAt?: Date;
    steps?: Array<StepLogDto>;
    state?: { [key: string]: any; };
    outputData?: { [key: string]: any; };
    totalAiInputTokens?: number;
    totalAiOutputTokens?: number;
    totalAiTotalTokens?: number;
}
export namespace WorkflowInstanceDto {
    export type StatusEnum = 'PENDING' | 'RUNNING' | 'COMPLETED' | 'FAILED' | 'PAUSED' | 'CANCELLED';
    export const StatusEnum = {
        PENDING: 'PENDING' as StatusEnum,
        RUNNING: 'RUNNING' as StatusEnum,
        COMPLETED: 'COMPLETED' as StatusEnum,
        FAILED: 'FAILED' as StatusEnum,
        PAUSED: 'PAUSED' as StatusEnum,
        CANCELLED: 'CANCELLED' as StatusEnum
    };
}